import { AiOutlineCloseCircle } from "react-icons/ai";

export function getFunctionErrorMessage(error) {
  if (!error || !error.name) return null;

  if (error.name === "FunctionsRelayError") {
    return (
      <div style={{ paddingTop: "10px" }}>
        <p style={{ color: "red" }}>
          <AiOutlineCloseCircle className="alert-icon" /> Relay Error
        </p>
        <p style={{ marginLeft: "28px" }}>
          Our service is temporarily unavailable. Please try again later.
        </p>
      </div>
    );
  }

  if (error.name === "FunctionsFetchError") {
    return (
      <div style={{ paddingTop: "10px" }}>
        <p style={{ color: "red" }}>
          <AiOutlineCloseCircle className="alert-icon" /> Fetch Error
        </p>
        <p style={{ marginLeft: "28px" }}>
          Network error. Please check your internet connection and try again.
        </p>
      </div>
    );
  }

  if (error.name === "FunctionsHttpError") {
    return (
      <div style={{ paddingTop: "10px" }}>
        <p style={{ color: "red" }}>
          <AiOutlineCloseCircle className="alert-icon" /> HTTP Error
        </p>
        <p style={{ marginLeft: "28px" }}>
          Something went wrong while processing your request.
        </p>
      </div>
    );
  }

  return null;
}
